/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type ChannelsEnum = typeof ChannelsEnum[keyof typeof ChannelsEnum];


export const ChannelsEnum = {
  ADMIN_NOTIFICATIONS_CHANNEL: 'AdminNotificationsChannel',
  APP_VERSION_CHANNEL: 'AppVersionChannel',
  FLEET_MEMBERS_CHANNEL: 'FleetMembersChannel',
  FLEET_VEHICLES_CHANNEL: 'FleetVehiclesChannel',
  HANGAR_CHANNEL: 'HangarChannel',
  HANGAR_CREATE_CHANNEL: 'HangarCreateChannel',
  HANGAR_DESTROY_CHANNEL: 'HangarDestroyChannel',
  HANGAR_SYNC_CHANNEL: 'HangarSyncChannel',
  IMPORTS_CHANNEL: 'ImportsChannel',
  MODELS_CHANNEL: 'ModelsChannel',
  NOTIFICATIONS_CHANNEL: 'NotificationsChannel',
  ON_SALE_CHANNEL: 'OnSaleChannel',
  ON_SALE_HANGAR_CHANNEL: 'OnSaleHangarChannel',
  USER_NOTIFICATIONS_CHANNEL: 'UserNotificationsChannel',
  WISHLIST_CHANNEL: 'WishlistChannel',
  WISHLIST_CREATE_CHANNEL: 'WishlistCreateChannel',
  WISHLIST_DESTROY_CHANNEL: 'WishlistDestroyChannel',
} as const;
